export default __webpack_public_path__ + "static/media/box4.703aa3a9.svg";